import { render, staticRenderFns } from "./apicredentials.vue?vue&type=template&id=9a70673c&scoped=true"
import script from "./apicredentials.vue?vue&type=script&lang=js"
export * from "./apicredentials.vue?vue&type=script&lang=js"
import style0 from "./apicredentials.vue?vue&type=style&index=0&id=9a70673c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a70673c",
  null
  
)

export default component.exports